module.exports = __webpack_public_path__ + "Poppins-SemiBoldItalic.6dc518a37ee717f6c3b1.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-SemiBoldItalic.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-SemiBoldItalic.woff
// module chunks = styles